import React, { memo } from 'react';
import { IconWrapper, JobInfoWrapper, JobInfoTile } from './Styles';
import { TickSVG, WarningIcon } from '../../../images/svgIcons';

const StatusMetrics = props => {
  const { info, isShortMessageEnabled } = props;

  return (
    <JobInfoWrapper>
      {info.map(item => {
        return !item.status ? (item.id!==3 || isShortMessageEnabled) && (
          <JobInfoTile key={item.id}>
            <div>
              <p className="channel-name">{item.label}</p>
              <h3>
                {item.count}
                {item.total !== null && item.total !== undefined && `/${item.total}`}
              </h3>
            </div>
            <div className="channel-icon">{item.icon}</div>
          </JobInfoTile>
        ) : (
          <JobInfoTile key={item.id}>
            <div>
              <p className="job-status">{item.label}</p>
            </div>
            {item.status === 'success' && (
              <IconWrapper background={'#FFE713'}>
                <TickSVG />
              </IconWrapper>
            )}
            {item.status === 'failed' && (
                <WarningIcon />
            )}
          </JobInfoTile>
        );
      })}
    </JobInfoWrapper>
  );
};

export default memo(StatusMetrics);
